module.exports = __webpack_public_path__ + "static/media/house2.ee983ed8.png";